import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.handleOpen = this.onOpen.bind(this)
    document.addEventListener("$select2:open", this.handleOpen)
  }

  disconnect() {
    document.removeEventListener("$select2:open", this.handleOpen)
  }

  onOpen(event) {
    if (event.target !== this.element && !event.target.contains(this.element)) return

    this.decorateResults()
  }

  decorateResults() {
    requestAnimationFrame(() => {
      const dropdown = document.querySelector(".select2-container--open .select2-dropdown") ||
        document.querySelector(".select2-dropdown")
      if (!dropdown) return

      Array.from(this.element.options).forEach((option) => {
        const count = Number(option.dataset.occurrenceCount || 0)
        if (count < 1) return

        const result = dropdown.querySelector(`[id$="-${CSS.escape(option.value)}"]`)
        if (!result) return

        const name = option.dataset.jobName || option.text
        const metadata = option.text.slice(name.length).replace(/^\s*—\s*/, "")
        result.replaceChildren()

        const nameElement = document.createElement("span")
        nameElement.className = "job-occurrence-option-name"
        nameElement.textContent = name

        const metadataElement = document.createElement("span")
        metadataElement.className = "job-occurrence-option-metadata"
        metadataElement.textContent = metadata

        result.append(nameElement, metadataElement)
      })
    })
  }
}
